export default __webpack_public_path__ + "static/media/avatar.433aa9e0.svg";